import React, { forwardRef } from 'react'
import { List } from 'semantic-ui-react'
import moment from 'moment'
import PropTypes from "prop-types";
import { EntityTypes } from '../shared/constants';
import { useTextResources } from '../../language';
import BridgerPayCvv from './BridgerPayCvv';
import SimpleCvvInput from './SimpleCvvInput';
import { ECompanyPayment } from './paymentCommon';

const fmt = "MM/YYYY"
const CardList = forwardRef(({ items, authorization, onSelect, onSelectItem, selected, hotelId, is3DS, cvvSession, guestId, isCvvMandatory }, ref) => {
    const text = useTextResources();
    const cvvInputRef = ref;

    // Determine if CVV input should be shown for the selected card
    const shouldShowCvv = (item) => {
        if (item.PaymentTokenId !== selected) return false;      
        const provider = item.PaymentProviderID;
        
        // For BridgerPay with 3DS
        if (is3DS && provider === ECompanyPayment.BRIDGEPAY) return 'bridgerpay';
        
        // For Credit Guard or other providers 
        if (provider !== ECompanyPayment.BRIDGEPAY) return 'simple';
        
        return false;
    };

    return <List divided relaxed selection={(onSelect || onSelectItem) ? true : false} onItemClick={(e, item) => {
        if (onSelect) {
            onSelect(item.id)
        }
        if (onSelectItem) {
            onSelectItem(items.find(x => x.Id === item.id))
        }
    }} items={
        items.map(item => {
            const cvvType = shouldShowCvv(item);
            return {
                key: item.Id,
                id: item.Id,
                active: item.PaymentTokenId === selected || item.Id === selected,
                className: "card-item",
                icon: "credit card",
                header: `${item.CardCompanyName} for ${text(EntityTypes[item.EntityTypeID])}`,
                description: <table>
                    <tbody>
                        <tr>
                            <td>{text("CardNumber")}:</td>
                            <td>{`**** **** **** ${item.LastFourDigits}`}</td>
                            <td></td>
                            <td><b>{item.CompanyPaymentName}</b></td>
                        </tr>
                        <tr>
                            <td>{text("Expiry")}:</td>
                            <td>{`${moment(item.CreditCardExpirationDate).format(fmt)}`}</td>
                            <td></td>
                            <td>
                                {cvvType === 'bridgerpay' && <BridgerPayCvv ref={cvvInputRef} guestId={guestId} session={cvvSession} HotelId={hotelId}/>}
                                {cvvType === 'simple' && <SimpleCvvInput ref={cvvInputRef} isMandatory={isCvvMandatory} />}
                            </td>
                        </tr>
                    </tbody>
                </table>,
                content: authorization ? `Authorization amount: ${item.Amount},  Used: ${item.UsedAmount || 0}` : null
            }
        })
    }
    />
});

CardList.displayName = 'CardList';
CardList.propTypes = {
    items: PropTypes.array,
    authorization: PropTypes.bool,
    onSelect: PropTypes.func,
    selected: PropTypes.number,
    onSelectItem: PropTypes.func,
    is3DS: PropTypes.bool,
    hotelId: PropTypes.number,    
    cvvSession: PropTypes.string,
    guestId: PropTypes.number,
    isCvvMandatory: PropTypes.bool,
}
export default CardList